import { fetchPortalPayments } from '@/modules/portal/services/portalPayments.api';

/** Invoice view v1 is derived from tenant-scoped payment records. */
export async function fetchPortalInvoices() {
  return fetchPortalPayments();
}
